import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
    const navigate = useNavigate();
    return (
        <Layout>
            <div className="max-w-[560px] mx-auto text-center py-16" data-testid="payment-cancel-page">
                <XCircle size={48} weight="fill" className="mx-auto text-gray-400" />
                <h1 className="font-display-black text-2xl mt-6">Pagamento annullato</h1>
                <p className="text-sm text-gray-500 mt-2">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
                <button onClick={() => navigate("/piano")} data-testid="payment-cancel-back"
                        className="mt-8 h-11 px-6 bg-white/10 border border-white/20 text-sm font-semibold rounded-lg">
                    Torna ai piani
                </button>
            </div>
        </Layout>
    );
}
